import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
  },
  content: {
    height: '100%',
    width: '100%',
    flex: 1,
    minWidth: 0,
  },
  appHeader: {
    backgroundColor: theme.palette.common.white,
    height: 56,
    minHeight: 56,
    padding: '0 24px',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.gray.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: theme.zIndex.appBar,
    color: theme.palette.gray.main,
    boxSizing: 'border-box',
  },
  btnToggle: {
    borderRight: `1px solid ${theme.palette.gray.divider}`,
    borderLeft: `1px solid ${theme.palette.gray.divider}`,
    borderRadius: 0,
    height: '100%',
    width: 80,
    zIndex: 999,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobileAppLogo: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  rightMenu: {
    height: '100%',
    paddingLeft: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  searchDiv: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '0 1em',
    color: theme.palette.gray.main,
    position: 'relative',
  },
  recentSearches: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: theme.zIndex.speedDial,
    minHeight: 80,
    borderTop: `1px solid ${theme.palette.gray.divider}`,
    boxShadow: '0 10px 15px 0 rgba(0, 0, 0, 0.12)',
  },
  searchText: {
    marginLeft: 20,
  },
  avatarRoot: {
    width: 'auto',
    height: '100%',
    padding: '0 0 0 8px',
    borderRadius: 8,
    cursor: 'pointer',
  },
  headerAvatar: {
    '&&': {
      width: 32,
      height: 32,
      minWidth: 32,
      minHeight: 32,
      maxWidth: 32,
      maxHeight: 32,
      borderRadius: '50%',
      fontSize: 12,
      fontWeight: 700,
      backgroundColor: '#f32445',
      color: theme.palette.common.white,
      flexShrink: 0,
      paddingLeft: 0,
    },
  },
  avatarTitle: {
    marginLeft: 10,
    marginRight: 4,
    maxWidth: 180,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobileToggle: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  userMenuHeader: {
    minWidth: 230,
    padding: '16px 16px 8px',
  },
  userMenuIcon: {
    width: 18,
    height: 18,
    marginRight: 12,
    color: theme.palette.text.secondary,
  },
  userMenuVersion: {
    padding: '10px 16px 12px',
    fontSize: 12,
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
}));